class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
// Randomise the grid only on the plain landing page. Any chosen sort or filter is obeyed.
document.addEventListener('DOMContentLoaded', () => {
if (window.location.search.indexOf('sort_by=') !== -1) return;
if (window.location.search.indexOf('filter.') !== -1 || window.location.pathname.indexOf('/search') === 0) return;
const grid = document.getElementById('product-grid');
document.querySelectorAll('select[name="sort_by"]').forEach((s) => { const o = document.createElement('option'); o.value = ''; o.textContent = 'Featured'; o.selected = true; s.insertBefore(o, s.firstChild); });
if (!grid) return;
const ul = grid.querySelector('ul.product-grid');
if (!ul) return;
const items = Array.from(ul.children);
for (let i = items.length - 1; i > 0; i--) {
const j = Math.floor(Math.random() * (i + 1));
ul.appendChild(items[j]);
items.splice(j, 1);
}
});


// Homepage filter links arrive as #filter-<name>: open that filter on landing.
document.addEventListener('DOMContentLoaded', () => {
const m = (window.location.hash || '').match(/^#filter-([a-z]+)/i);
if (!m) return;
const want = m[1].toLowerCase();
const all = Array.from(document.querySelectorAll('details.facets__disclosure'));
const d = all.find((x) => ((x.querySelector('summary') || {}).textContent || '').trim().toLowerCase().indexOf(want) === 0);
if (!d) return;
d.open = true;
setTimeout(() => { d.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 60);
});
